import React from 'react';
import Tooltip, { TooltipPlacement } from 'features/shared/Tooltip';
import { useClickStreamContext } from 'features/shared/ClickStream';
import pluralize from 'utils/pluralize';
import {
  HeaderTitle,
  Hr,
  Name,
  NameHeader,
  Persent,
  Progress,
  ProgressBlock,
  ProgressLabel,
  RowBoby,
  RowChart,
  ScrollBlock,
  WrapCell,
  WrapChart,
} from '../../styled';
import { Space } from '@gr-monorepo/common/ui';
import { IMunicipalityStatistics } from '../../useMunicipalityStatistics';

export const ChartRow = (props: {
  subjectId: number;
  subjectName: string;
  value: number;
  participantsCount: number;
  realStudentsCount: number;
  num: number;
  color: string;
}) => {
  const { logPageEvent } = useClickStreamContext();

  const titleTooltip =
    `${props.participantsCount}` + ' ' + pluralize(props.participantsCount || 0, ['ученик', 'ученика', 'учеников']);
  return (
    <RowBoby>
      <WrapCell>
        <Name>{props.subjectName}</Name>
      </WrapCell>

      <Persent>
        <Tooltip
          title={titleTooltip}
          arrow
          placement={TooltipPlacement.Top}
          onShow={() => {
            logPageEvent?.({
              eventType: 'regional_rating_tooltip_count_students',
              eventInfo: 'Региональный рейтинг: Показ тултипа "Количество учеников"',
            });
          }}
        >
          <Progress style={{ width: `${props.value}%` }}>
            <ProgressBlock/>
          </Progress>
        </Tooltip>

        <ProgressLabel>{props.value}%</ProgressLabel>
      </Persent>
    </RowBoby>
  );
};

const Chart = (props: { rows: IMunicipalityStatistics[]; color: string }) => {
  return (
    <WrapChart>
      <RowChart style={{ marginBottom: 0 }}>
        <NameHeader>Муниципалитеты</NameHeader>
        <Persent style={{ margin: 0 }}>
          <HeaderTitle>Доля участников олимпиады от общего количества школьников в муниципалитетах региона</HeaderTitle>
        </Persent>
      </RowChart>
      <Space axis="vertical" size={8} />
      <Hr />

      <ScrollBlock>
        {props.rows.map((el, i) => (
          <ChartRow key={i} num={i + 1} {...el} color={props.color} />
        ))}
      </ScrollBlock>
      <Hr />
      <Space axis="vertical" size={12} />
    </WrapChart>
  );
};

export default Chart;
